import { DropDownCategories } from 'src/types/generic';

export const WORK_AREA_COMPANY_TREE_FILTER_STORAGE_KEY = 'work-area-company-tree-filter';
export const WORK_AREA_USER_COMPANIES_FILTER_STORAGE_KEY = 'work-area-user-companies-filter';

export const WorkAreaFilterCategories: DropDownCategories[] = [
  { value: 1, label: 'Show Active' },
  { value: 2, label: 'Show Disabled' },
  { value: 0, label: 'Show All' },
];
